<p-toast></p-toast>

<p-sidebar [(visible)]="rightSideBar" position="right" [baseZIndex]="10000">
  <app-side-bar></app-side-bar>
</p-sidebar>
<div class="mw-100">
  <mat-toolbar>
    <mat-toolbar-row class="mt-20" *ngIf="idrol=== 1 || idrol===2">

      <span><img src="assets/MicrosoftTeams-image.png" class="logoStyle"></span>
      <span class="ml-amr-10">
        <button pButton (click)="root.toggle($event)" class="btnCust">
          <img src="assets/user-avatar.png" class="imgStyle" />
          <span class="p-ml-2 cstF1"> {{nameUser}} <br />
            <span class="p-ml-2 cstF2">{{nameRol}}</span>
          </span>
        </button>
        <span class="sbh">
          <button pButton pRipple type="button" icon="pi pi-align-justify" class="p-button-rounded p-button-text"
            (click)="rightSB()">
          </button>
        </span>
        <p-dropdown 
          [options]="languages"
          [ngModel]="currentLang" 
          (ngModelChange)="changeLanguage($event)"
          class="custom-dropdown"
          placeholder="{{ 'LANGUAGE' | translate }}">
          <ng-template let-lang pTemplate="selectedItem">
             {{ lang.label }}
          </ng-template>
          <ng-template let-lang pTemplate="item">
            <i [class]="lang.icon"></i> {{ lang.label }}
          </ng-template>
        </p-dropdown>


        <p-menu #root [popup]="true" [model]="items"></p-menu>
      </span>
    </mat-toolbar-row>

    <mat-toolbar-row class="mt-20" *ngIf="idrol=== 3">

      <span><img src="assets/logo-dark.png" class="logoStyle"></span>
      <span class="ml-amr-10">
        <button pButton (click)="operator.toggle($event)" class="btnCust">
          <img src="assets/user-avatar.png" class="imgStyle" />
          <span class="p-ml-2 cstF1"> {{nameUser}} <br />
            <span class="p-ml-2 cstF2">{{nameRol}}</span>
          </span>
        </button>
        <span class="sbh">
          <button pButton pRipple type="button" icon="pi pi-align-justify" class="p-button-rounded p-button-text"
            (click)="rightSB()">
          </button>
        </span>

        <p-menu #operator [popup]="true" [model]="itemsOperador"></p-menu>
      </span>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <hr />
    </mat-toolbar-row>

    <mat-toolbar-row *ngIf="idrol=== 3">
      <span class="shb"><p-tabMenu [model]="operador" [activeItem]="activeItem"></p-tabMenu></span><br />
    </mat-toolbar-row>

    <mat-toolbar-row *ngIf="idrol=== 1 || idrol=== 2">

      <span class="shb"><p-tabMenu [model]="tabitems" [activeItem]="activeItem"></p-tabMenu></span><br />
    </mat-toolbar-row>
  </mat-toolbar>
</div>